import * as f from "react";
import { p } from "./index-efd35e77.js";
import { l as U, v as j } from "./index-64063129.js";
var O = f.createContext(null), T = function() {
  for (var r = [], n = 0; n < arguments.length; n++)
    r[n] = arguments[n];
  var i = {}, e = function(o) {
    return typeof o == "object" ? Object.keys(o).forEach(function(a) {
      i[a] = o[a];
    }) : i[o] = !0;
  }, t = function(o) {
    return o.filter(function(a) {
      return a !== !0 && !!a;
    }).map(function(a) {
      return Array.isArray(a) ? t(a) : e(a);
    });
  };
  return t(r), Object.keys(i).map(function(o) {
    return i[o] && o || null;
  }).filter(function(o) {
    return o !== null;
  }).join(" ");
}, C = function(r) {
  return r ? new Date(r.getTime()) : null;
};
function b(r) {
  var n = {};
  return _(r, n), n;
}
function _(r, n) {
  for (var i in r)
    if (r.hasOwnProperty(i)) {
      var e = r[i];
      n[i] = A(e, n[i]);
    }
}
function A(r, n) {
  if (Array.isArray(r))
    return R(r);
  if (r instanceof Date)
    return C(r);
  if (f.isValidElement(r))
    return f.cloneElement(r, r.props);
  if (r && typeof r == "object") {
    var i = n || {};
    return _(r, i), i;
  } else
    return r;
}
function R(r) {
  return r.map(function(n) {
    return A(n, void 0);
  });
}
var k = /\[(?:(\d+)|['"](.*?)['"])\]|((?:(?!\[.*?\]|\.).)+)/g;
function P(r) {
  var n = [];
  return r.replace(k, function(i, e, t, o) {
    n.push(e !== void 0 ? e : t || o);
  }), n;
}
var m = {};
m.undefined = function() {
};
function B(r) {
  if (m[r])
    return m[r];
  var n = P(r);
  return m[r] = function(i) {
    for (var e = i, t = 0; t < n.length && e; t++)
      e = e[n[t]];
    return e;
  }, m[r];
}
var F = function() {
  var r = "", n, i;
  for (n = 0; n < 32; n++)
    i = Math.random() * 16 | 0, (n === 8 || n === 12 || n === 16 || n === 20) && (r += "-"), r += (n === 12 ? 4 : n === 16 ? i & 3 | 8 : i).toString(16);
  return r;
}, h = {};
h.undefined = function(r) {
  return r;
};
var V = function(r, n) {
  return n && n.arrays && !isNaN(Number(r)) ? [] : {};
};
function M(r) {
  if (h[r])
    return h[r];
  var n = P(r);
  return h[r] = function(i, e, t) {
    for (var o = i, a = n.length - 1, u = 0; u < a && o; u++)
      o = o[n[u]] = o[n[u]] || V(n[u + 1], t);
    o[n[a]] = e;
  }, h[r];
}
function I(r) {
  if (typeof U < "u")
    j(r);
  else {
    var n = "License activation failed for ".concat(r.name, `
`);
    n += `The @progress/kendo-licensing script is not loaded.
`, n += "See ".concat(r.licensingDocsUrl, ` for more information.
`), console.warn(n);
  }
}
var G = {
  sizeMap: {
    small: "sm",
    medium: "md",
    large: "lg"
  },
  roundedMap: {
    small: "sm",
    medium: "md",
    large: "lg"
  }
}, N = {
  name: "@progress/kendo-react-form",
  productName: "KendoReact",
  productCodes: ["KENDOUIREACT", "KENDOUICOMPLETE"],
  publishDate: 1686225633,
  version: "",
  licensingDocsUrl: "https://www.telerik.com/kendo-react-ui/my-license/?utm_medium=product&utm_source=kendoreact&utm_campaign=kendo-ui-react-purchase-license-keys-warning"
}, x = globalThis && globalThis.__extends || function() {
  var r = function(n, i) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, t) {
      e.__proto__ = t;
    } || function(e, t) {
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }, r(n, i);
  };
  return function(n, i) {
    if (typeof i != "function" && i !== null)
      throw new TypeError("Class extends value " + String(i) + " is not a constructor or null");
    r(n, i);
    function e() {
      this.constructor = n;
    }
    n.prototype = i === null ? Object.create(i) : (e.prototype = i.prototype, new e());
  };
}(), c = globalThis && globalThis.__assign || function() {
  return c = Object.assign || function(r) {
    for (var n, i = 1, e = arguments.length; i < e; i++) {
      n = arguments[i];
      for (var t in n)
        Object.prototype.hasOwnProperty.call(n, t) && (r[t] = n[t]);
    }
    return r;
  }, c.apply(this, arguments);
}, v = globalThis && globalThis.__spreadArray || function(r, n, i) {
  if (i || arguments.length === 2)
    for (var e = 0, t = n.length, o; e < t; e++)
      (o || !(e in n)) && (o || (o = Array.prototype.slice.call(n, 0, e)), o[e] = n[e]);
  return r.concat(o || Array.prototype.slice.call(n));
}, D = 0, $ = (
  /** @class */
  function(r) {
    x(n, r);
    function n(i) {
      var e = r.call(this, i) || this;
      return e._id = F(), e._touched = {}, e._visited = {}, e._modified = {}, e._validatorsByField = {}, e._values = {}, e._fields = {}, e._unmounted = !1, e._submitted = !1, e.isValid = function() {
        return e.isFormValid(e.errors);
      }, e.accumulatedForceUpdate = function() {
        e._accumulatorTimeout && clearTimeout(e._accumulatorTimeout), e._accumulatorTimeout = window.setTimeout(function() {
          e._accumulatorTimeout = void 0, e.forceUpdate();
        }, D);
      }, e.resetForm = function() {
        e.values = b(e.props.initialValues), e._id = F(), e._touched = {}, e._visited = {}, e._modified = {}, e._validatorsByField = {}, e._fields = {}, e._submitted = !1, e.forceUpdate();
      }, e.onReset = function() {
        return e.resetForm();
      }, e.addField = function(t) {
        e._fields[t] = !0;
      }, e.onSubmit = function(t) {
        var o = {}, a = e.fields;
        t && (typeof t.preventDefault == "function" && t.preventDefault(), typeof t.stopPropagation == "function" && t.stopPropagation()), a.forEach(function(d) {
          o[d] = !0;
        }), e.visited = c({}, o), e.touched = c({}, o);
        var u = e.values, s = e.isFormValid(e.errors), l = e.isFormModified(e.modified, a);
        e.props.onSubmitClick && e.props.onSubmitClick.call(void 0, {
          values: u,
          isValid: s,
          isModified: l,
          event: t
        }), s && (e.props.ignoreModified || l) && e.props.onSubmit && (e._submitted = !0, e.props.onSubmit.call(void 0, u, t)), e.forceUpdate();
      }, e.onChange = function(t, o) {
        var a, u = o.value;
        e.addField(t), e.modified[t] || (e.modified = c(c({}, e.modified), (a = {}, a[t] = !0, a))), e.valueSetter(t, u), e.forceUpdate();
      }, e.onFocus = function(t, o) {
        var a;
        e.visited[t] || (e.visited = c(c({}, e.visited), (a = {}, a[t] = !0, a)), o || e.forceUpdate());
      }, e.onBlur = function(t, o) {
        var a;
        e.touched[t] || (e.onFocus(t, o), e.touched = c(c({}, e.touched), (a = {}, a[t] = !0, a)), o || e.forceUpdate());
      }, e.onFieldRegister = function(t, o) {
        var a;
        e.addField(t);
        var u = e.validatorsByField[t] || [], s = u.length;
        return e.validatorsByField = c(c({}, e.validatorsByField), (a = {}, a[t] = v(v([], u, !0), [o], !1), a)), e.accumulatedForceUpdate(), function() {
          var l;
          if (!e._unmounted) {
            var d = v([], e.validatorsByField[t] || [], !0), y = !!d[s];
            d[s] = void 0, e.validatorsByField = c(c({}, e.validatorsByField), (l = {}, l[t] = d, l)), y && e.accumulatedForceUpdate();
          }
        };
      }, e.isFormValid = function(t) {
        return !Object.keys(t).some(function(o) {
          return !!t[o];
        });
      }, e.isFormModified = function(t, o) {
        return o.some(function(a) {
          return t[a];
        });
      }, e.isFormHasNotTouched = function(t, o) {
        return o.some(function(a) {
          return !t[a];
        });
      }, e.isFormTouched = function(t, o) {
        return o.some(function(a) {
          return t[a];
        });
      }, e.isFormVisited = function(t, o) {
        return o.some(function(a) {
          return t[a];
        });
      }, e.valueGetter = function(t) {
        return B(t)(e.values);
      }, e.valueSetter = function(t, o) {
        return M(t)(e.values, o);
      }, e.onArrayAction = function(t) {
        var o;
        e.addField(t), e.modified[t] || (e.modified = c(c({}, e.modified), (o = {}, o[t] = !0, o))), e.onBlur(t, !0);
      }, e.onInsert = function(t, o) {
        e.onArrayAction(t);
        var a = v([], e.valueGetter(t) || [], !0);
        a.splice(o.index, 0, o.value), e.valueSetter(t, a), e.forceUpdate();
      }, e.onUnshift = function(t, o) {
        e.onInsert(t, {
          value: o.value,
          index: 0
        });
      }, e.onPush = function(t, o) {
        e.onArrayAction(t);
        var a = v(v([], e.valueGetter(t) || [], !0), [o.value], !1);
        e.valueSetter(t, a), e.forceUpdate();
      }, e.onPop = function(t) {
        e.onArrayAction(t);
        var o = v([], e.valueGetter(t) || [], !0), a = o.pop();
        return e.valueSetter(t, o), e.forceUpdate(), a;
      }, e.onRemove = function(t, o) {
        e.onArrayAction(t);
        var a = v([], e.valueGetter(t) || [], !0), u = a.splice(o.index, 1);
        return e.valueSetter(t, a), e.forceUpdate(), u;
      }, e.onReplace = function(t, o) {
        e.onArrayAction(t);
        var a = v([], e.valueGetter(t) || [], !0);
        a.splice(o.index, 1, o.value), e.valueSetter(t, a), e.forceUpdate();
      }, e.onMove = function(t, o) {
        e.onArrayAction(t);
        var a = v([], e.valueGetter(t) || [], !0), u = a[o.prevIndex];
        a.splice(o.prevIndex, 1), a.splice(o.nextIndex, 0, u), e.valueSetter(t, a), e.forceUpdate();
      }, I(N), e.values = b(i.initialValues), e;
    }
    return Object.defineProperty(n.prototype, "touched", {
      /**
       * @hidden
       */
      get: function() {
        return this._touched;
      },
      /**
       * @hidden
       */
      set: function(i) {
        this._touched = i;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n.prototype, "visited", {
      /**
       * @hidden
       */
      get: function() {
        return this._visited;
      },
      /**
       * @hidden
       */
      set: function(i) {
        this._visited = i;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n.prototype, "modified", {
      /**
       * @hidden
       */
      get: function() {
        return this._modified;
      },
      /**
       * @hidden
       */
      set: function(i) {
        this._modified = i;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n.prototype, "validatorsByField", {
      /**
       * @hidden
       */
      get: function() {
        return this._validatorsByField;
      },
      /**
       * @hidden
       */
      set: function(i) {
        this._validatorsByField = i;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n.prototype, "values", {
      /**
       * @hidden
       */
      get: function() {
        return this._values;
      },
      /**
       * @hidden
       */
      set: function(i) {
        this._values = i;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n.prototype, "fields", {
      /**
       * @hidden
       */
      get: function() {
        return Object.keys(this._fields);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n.prototype, "formErrors", {
      /**
       * @hidden
       */
      get: function() {
        if (this.props.validator)
          return this.props.validator(this.values, this.valueGetter);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n.prototype, "errors", {
      /**
       * @hidden
       */
      get: function() {
        var i = this, e = {}, t = this.fields, o = this.validatorsByField;
        t.forEach(function(u) {
          if (e[u] = "", o[u]) {
            var s = [];
            o[u].forEach(function(l) {
              Array.isArray(l) ? s.push.apply(s, l) : s.push(l);
            }), s.find(function(l) {
              if (l) {
                var d = l(i.valueGetter(u), i.valueGetter, { name: u });
                if (d)
                  return e[u] = d, !0;
              }
              return !1;
            });
          }
        });
        var a = this.formErrors;
        return a && _(this.formErrors, e), e;
      },
      enumerable: !1,
      configurable: !0
    }), n.prototype.componentWillUnmount = function() {
      this._unmounted = !0, this._accumulatorTimeout && clearTimeout(this._accumulatorTimeout);
    }, n.prototype.render = function() {
      var i = this.props.render, e = this.touched, t = this.visited, o = this.modified, a = this.fields, u = this.errors, s = this.isFormValid(u), l = this.isFormModified(o, a), d = this.isFormTouched(e, a), y = this.isFormVisited(t, a), E = this.isFormHasNotTouched(e, a), w = E && !s || s && (this.props.ignoreModified || l);
      return f.createElement(O.Provider, { key: this._id, value: {
        id: this._id,
        valueGetter: this.valueGetter,
        errors: u,
        modified: o,
        touched: e,
        visited: t,
        registerField: this.onFieldRegister,
        onSubmit: this.onSubmit,
        onChange: this.onChange,
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        onUnshift: this.onUnshift,
        onPush: this.onPush,
        onInsert: this.onInsert,
        onPop: this.onPop,
        onRemove: this.onRemove,
        onReplace: this.onReplace,
        onMove: this.onMove
      } }, i({
        valid: s,
        modified: l,
        touched: d,
        visited: y,
        submitted: this._submitted,
        valueGetter: this.valueGetter,
        errors: u,
        allowSubmit: w,
        onChange: this.onChange,
        onSubmit: this.onSubmit,
        onFormReset: this.resetForm
      }));
    }, n.displayName = "KendoReactForm", n.propTypes = {
      initialValues: p.any,
      onSubmit: p.func,
      onSubmitClick: p.func,
      render: p.func.isRequired
    }, n;
  }(f.Component)
), z = function(r) {
  var n = T({
    "k-form-field": !0,
    "k-rtl": r.dir === "rtl"
  }, r.className);
  return f.createElement("div", { className: n, style: r.style }, r.children);
};
z.displayName = "KendoReactFieldWrapper";
var g = globalThis && globalThis.__assign || function() {
  return g = Object.assign || function(r) {
    for (var n, i = 1, e = arguments.length; i < e; i++) {
      n = arguments[i];
      for (var t in n)
        Object.prototype.hasOwnProperty.call(n, t) && (r[t] = n[t]);
    }
    return r;
  }, g.apply(this, arguments);
}, K = globalThis && globalThis.__rest || function(r, n) {
  var i = {};
  for (var e in r)
    Object.prototype.hasOwnProperty.call(r, e) && n.indexOf(e) < 0 && (i[e] = r[e]);
  if (r != null && typeof Object.getOwnPropertySymbols == "function")
    for (var t = 0, e = Object.getOwnPropertySymbols(r); t < e.length; t++)
      n.indexOf(e[t]) < 0 && Object.prototype.propertyIsEnumerable.call(r, e[t]) && (i[e[t]] = r[e[t]]);
  return i;
}, S = f.forwardRef(function(r, n) {
  var i, e = f.useRef(null), t = f.useRef(null);
  f.useImperativeHandle(t, function() {
    return { element: e.current, props: r };
  }), f.useImperativeHandle(n, function() {
    return t.current;
  });
  var o = f.useContext(O), a = r.className;
  r.onSubmit, r.style;
  var u = r.horizontal, s = r.size, l = K(r, ["className", "onSubmit", "style", "horizontal", "size"]), d = T((i = {
    "k-form": !0
  }, i["k-form-".concat(G.sizeMap[s] || s)] = s, i["k-form-horizontal"] = u === !0, i), a);
  return f.createElement("form", g({ ref: e }, l, { style: r.style, className: d, onSubmit: o ? o.onSubmit : void 0 }), r.children);
}), L = {
  size: "medium"
};
S.displayName = "KendoReactFormElement";
S.defaultProps = L;
export {
  z as F,
  O as a,
  $ as b,
  S as c
};
